// modDESIGN Theme JS — Clean Build
// All errors from previous versions fixed

// Cursor — desktop only, wrapped in hover check
if (window.matchMedia('(hover: hover)').matches) {
  const cur = document.getElementById('cur');
  const crng = document.getElementById('crng');
  if (cur && crng) {
    let rx = 0, ry = 0, mx = 0, my = 0;
    document.addEventListener('mousemove', e => {
      mx = e.clientX; my = e.clientY;
      cur.style.left = mx + 'px'; cur.style.top = my + 'px';
    });
    (function anim() {
      rx += (mx - rx) * .1; ry += (my - ry) * .1;
      crng.style.left = rx + 'px'; crng.style.top = ry + 'px';
      requestAnimationFrame(anim);
    })();
    document.querySelectorAll('a,button,.cat-card,.faq-item').forEach(el => {
      el.addEventListener('mouseenter', () => { cur.style.width = '14px'; cur.style.height = '14px'; crng.style.width = '44px'; crng.style.height = '44px'; });
      el.addEventListener('mouseleave', () => { cur.style.width = '8px'; cur.style.height = '8px'; crng.style.width = '28px'; crng.style.height = '28px'; });
    });
  }
}

// Nav scroll
window.addEventListener('scroll', () => {
  const nav = document.getElementById('nav');
  if (nav) nav.classList.toggle('stuck', scrollY > 60);
});

// Parallax
window.addEventListener('scroll', () => {
  const prlx = document.getElementById('prlx');
  if (prlx) {
    const r = prlx.parentElement.getBoundingClientRect();
    if (r.top < innerHeight && r.bottom > 0) {
      prlx.style.transform = 'translateY(' + ((scrollY - prlx.parentElement.offsetTop) * .22) + 'px)';
    }
  }
});

// Mobile menu
function closeMobile() {
  const m = document.getElementById('mobileMenu');
  if (m) m.classList.remove('open');
}
const ham = document.getElementById('hamburger');
const mMenu = document.getElementById('mobileMenu');
const mClose = document.getElementById('menuClose');
if (ham) ham.addEventListener('click', () => mMenu && mMenu.classList.add('open'));
if (mClose) mClose.addEventListener('click', closeMobile);

// FAQ toggle
function toggleFaq(el) {
  const isOpen = el.classList.contains('open');
  document.querySelectorAll('.faq-item').forEach(f => {
    f.classList.remove('open');
    const icon = f.querySelector('.faq-icon');
    if (icon) icon.textContent = '+';
  });
  if (!isOpen) {
    el.classList.add('open');
    const icon = el.querySelector('.faq-icon');
    if (icon) icon.textContent = '\u2212';
  }
}

// Scroll animations — disabled on mobile for performance
const isMobile = window.innerWidth <= 768;
if (!isMobile) {
  const io = new IntersectionObserver(entries => {
    entries.forEach(e => {
      if (e.isIntersecting) {
        e.target.style.opacity = '1';
        e.target.style.transform = 'translateY(0)';
        io.unobserve(e.target);
      }
    });
  }, { threshold: 0.08 });
  document.querySelectorAll('.cat-card,.step,.srv-card,.faq-item,.about-pill,.why-card,.b2b-srv,.b2b-step,.pain-item,.ba-item,.cs-result').forEach(el => {
    el.style.opacity = '0';
    el.style.transform = 'translateY(18px)';
    el.style.transition = 'opacity .6s ease, transform .6s ease, background .2s';
    io.observe(el);
  });
  document.querySelectorAll('.about-sec>div,.contact-sec>div,.why-grid>div,.cs-inner>div,.problem-grid>div').forEach(el => {
    el.style.opacity = '0';
    el.style.transform = 'translateY(22px)';
    el.style.transition = 'opacity .7s ease, transform .7s ease';
    io.observe(el);
  });
}

// Form submit
function handleSubmit(e) {
  e.preventDefault();
  const ok = document.getElementById('fok');
  if (ok) ok.style.display = 'block';
  e.target.querySelectorAll('input,select,textarea,button').forEach(f => f.disabled = true);
}

// ── modDESIGN v12 ──

// LOADER
(function() {
  var loader = document.getElementById('mod-loader');
  var bar = document.getElementById('mod-loader-bar');
  var pct = document.getElementById('mod-loader-pct');
  var tag = document.getElementById('mod-loader-tag');
  if (!loader) return;

  // Animate bar
  setTimeout(function() {
    bar.style.transition = 'width 2s cubic-bezier(.4,0,.2,1)';
    bar.style.width = '100%';
  }, 300);

  // Counter
  var count = 0;
  setTimeout(function() {
    var iv = setInterval(function() {
      count += count < 68 ? 2 : 1;
      if (count >= 100) { count = 100; clearInterval(iv); }
      pct.textContent = count + '%';
    }, 36);
  }, 300);

  // Tagline type
  setTimeout(function() {
    tag.style.transition = 'width 1.4s steps(30,end)';
    tag.style.width = '260px';
  }, 800);

  // Dismiss
  setTimeout(function() {
    loader.classList.add('mod-loader-gone');
    // Once loader gone, show body and start scrub
    document.body.style.overflow = '';
    initScrub();
  }, 3000);

  // Lock scroll during loader
  document.body.style.overflow = 'hidden';
})();

// SCROLL SCRUB HERO
function initScrub() {
  var video = document.getElementById('mod-hero-video');
  var zone = document.getElementById('mod-scroll-zone');
  if (!video || !zone) return;

  video.pause();
  video.currentTime = 0;

  var ticking = false;

  function update() {
    var zoneTop = zone.getBoundingClientRect().top + window.pageYOffset;
    var zoneHeight = zone.offsetHeight - window.innerHeight;
    var scrolled = Math.max(0, window.pageYOffset - zoneTop);
    var progress = Math.min(1, Math.max(0, scrolled / zoneHeight));

    if (video.readyState >= 2 && video.duration) {
      video.currentTime = progress * video.duration;
    }
    ticking = false;
  }

  window.addEventListener('scroll', function() {
    if (!ticking) {
      requestAnimationFrame(update);
      ticking = true;
    }
  }, { passive: true });
}
